<template>
    <el-row>
        <el-col :xs="24" :md="18">
            <div class="middle-filter-logic">
                <span>
                    过滤条件匹配：
                </span>
                <el-select v-model="logic" placeholder="Select" style="width:235px">
                    <el-option
                        v-for="item in logicOptions"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                        />
                </el-select>
            </div>
            <div class="middle-filter-body">
                <filter-item class="filterItem" v-for="item in filters"
                    @addItem = "newFilterItem"
                    @deleteItem ="deleteFilterItem"
                    :key = "item.guid"
                    :filterItem = "item"
                    :contentType="contentType"
                    :supportSelectedFields = "supportSelectedFields">
                </filter-item>
            </div>
        </el-col>
        <el-col :xs="24" :md="6">
            <local-storage-save 
                ref="saveLocal" 
                title="保存的查询"
                :localStorageKey="guid"
                @selectValue="setFilters"></local-storage-save>
        </el-col>
    </el-row>
    
    <el-row style="margin-top:20px">
        <el-col :span="18">
            <el-button @click="resetFilter">重置</el-button>
            <el-button @click="saveLocal">保存查询条件</el-button>
        </el-col>
        <el-col :span="6">
            <el-button @click="cancel">关闭</el-button>
            <el-button type="success" @click="queryFilter">查询</el-button>
        </el-col>
    </el-row>
</template>

<style>
    .middle-filter-logic{
        margin: 0px 8px 16px 8px;
    }
    
    .filterItem{
        margin-bottom: 8px;
        display: flex;
    }

</style>

<script>
    import { getFieldDefinition } from "@/apis/httpHelper" 
    import { qweGuid } from "@/common/commonHelper";
    import FilterItem from "./SingleFilterItem.vue";
    import localStorageSave from "../../LoaclStorage/localStorageSave.vue";
    import { ElMessageBox, ElMessage } from "element-plus";
    import { checkFilter,FilterConfig } from "../index";


    export default {
        name:"middleFilter",
        props:{
            guid:{
                type: String,
            },

            contentType:{
                type: String,
            },

            filterOperatorConfig:{
                type:Object,
                default:function(){
                    return {}
                }
            },

            fields:{
                type: Array
            },

            fieldDefinitions:{
                type: Array
            }
        },

        emits:[
            "cancel",
            "success",
            "resetfilter"
        ],

        provide:function(){
            return {
                contentType:this.contentType,
                buildFormContext:this.buildFormContext
            }
        },

        components:{
            'filter-item':FilterItem,
            'local-storage-save':localStorageSave
        },

        data:function(){
            return {
                supportSelectedFields:[],

                logicOptions:[{
                    text:"AND（所有条件都要求匹配）",
                    value:"and"
                },{
                    text:"OR（条件中的任意一个匹配）",
                    value:"or"
                }],

                logic:"and",
                filters:[],

                formContext:{}
            }
        },
        

        created:function(){
            if((this.fieldDefinitions || []).length > 0){
                let result = this.fieldDefinitions.map(x=>{
                    let text = this.filterOperatorConfig[x.Name]?.displayName || x.Settings.ContentPartFieldSettings.DisplayName;
                    let value = x.Name;
                    return {
                        text: text,
                        value: value,
                        fieldType: x.FieldDefinition.Name,
                        definition:x
                    }
                });
                
                this.supportSelectedFields = result;
                this.newFilterItem(); 
            }
            else{
                getFieldDefinition(this.contentType,this.fields)
                .then(x=>{
                    let result = x.Result.map(x=>{
                        let text = this.filterOperatorConfig[x.Name]?.displayName || x.Settings.ContentPartFieldSettings.DisplayName;
                        let value = x.Name;
                        return {
                            text: text,
                            value: value,
                            fieldType: x.FieldDefinition.Name,
                            definition:x
                        }
                    });
                    this.supportSelectedFields = result;
                    this.newFilterItem(); 
                }).catch(x=>{
                    console.log(x)
                })
            }
            getFieldDefinition(this.contentType).then(x=>{
                let fields = x.Result;
                fields.forEach(field => this.formContext[field.Name] = null);
            })   
        },

        methods:{
            buildFormContext:function(){
                return { 
                    Content:this.formContext,
                    UserInfo:this.$store.state.userInfo,
                    Properties:{
                        Env:"Filter" 
                    }
                }; 
            },

            newFilterItem:function(){
                this.filters.push({
                    "fieldType":"NoTypeField",
                    "field":"",
                    "operator":"",
                    "value":[],
                    "guid":qweGuid(10)
                })
            },

            deleteFilterItem:function(guid){
                let index = this.filters.findIndex(x=> x.guid == guid);
                this.filters.splice(index,1);
            },

            resetFilter:function(){
                this.filters = [{
                    "fieldType":"NoTypeField",
                    "field":"",
                    "operator":"",
                    "value":[],
                    "guid":qweGuid(10)
                }];
            },

            checkFilters:function(){
                let filters = this.filters || [];
                for(let i = 0;i < filters.length; i++){
                    let filter = filters[i];
                    if(!checkFilter(filter)){
                        ElMessage.warning("当前包含空的过滤条件");
                        return false;
                    }
                }
                return true;
            },

            saveLocal:function(){
                if(this.checkFilters()){
                    ElMessageBox.prompt('','请输入保存的名称',{
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(({ value })=>{
                        let saveObj = {
                            "logic":this.logic,
                            "filters":this.filters
                        }
                        this.$refs.saveLocal.addItem(value, saveObj);
                        ElMessage.success("查询已保存")
                    }).catch(e=>{});
                }
            },

            setFilters:function(value){
                let valueObj = JSON.parse(JSON.stringify(value));
                this.logic = valueObj.logic;
                this.filters = valueObj.filters;
            },

            queryFilter:function(){
                if(this.checkFilters()){
                    let filters = (this.filters||[]).map(x=>{
                        let data = {
                            field: x.field,
                            operator: x.operator,
                            value: x.value
                        }
                        return FilterConfig[x.fieldType].buildFilter(data);
                    });
                    this.$emit("success", { "logic":this.logic,"filters":filters });
                }
            },

            cancel:function(){
                this.$emit("cancel");
            }
        }        
    }
</script>